import { useState, useEffect } from 'react'
import { supabase } from '../lib/supabase'
import api from '../services/api'

export default function Usuarios() {
    const [users, setUsers] = useState([])
    const [companies, setCompanies] = useState([])
    const [showForm, setShowForm] = useState(false)
    const [form, setForm] = useState({ name: '', email: '', password: '', company_id: '' })
    const [loading, setLoading] = useState(false)
    const [msg, setMsg] = useState('')
    const [confirmDelete, setConfirmDelete] = useState(null)
    const [confirmPromote, setConfirmPromote] = useState(null)

    useEffect(() => {
        supabase.from('profiles').select('*, companies(name)').order('created_at').then(({ data }) => setUsers(data || []))
        api.get('/companies').then(r => setCompanies(r.data))
    }, [])

    const handleCreate = async () => {
        if (!form.name || !form.email || !form.password || !form.company_id) return
        setLoading(true)
        setMsg('')
        try {
            const response = await api.post('/auth/create-user', form)
            const data = response.data
            const company = companies.find(c => c.id === form.company_id)
            setUsers(prev => [...prev, {
                id: data.user.id,
                name: form.name,
                email: form.email,
                user_role: 'client',
                companies: { name: company?.name }
            }])
            setForm({ name: '', email: '', password: '', company_id: '' })
            setShowForm(false)
            setMsg('Usuário criado com sucesso!')
        } catch (err) {
            setMsg('Erro: ' + (err.response?.data?.error || err.message))
        }
        setLoading(false)
    }

    const handleDelete = async (user) => {
        try {
            await api.delete(`/auth/delete-user/${user.id}`)
            setUsers(prev => prev.filter(u => u.id !== user.id))
            setConfirmDelete(null)
            setMsg('Usuário excluído com sucesso!')
        } catch (err) {
            setMsg('Erro ao excluir: ' + (err.response?.data?.error || err.message))
        }
    }

    const handlePromote = async (user) => {
        try {
            await api.patch(`/auth/promote-user/${user.id}`)
            setUsers(prev => prev.map(u => u.id === user.id ? { ...u, user_role: 'master' } : u))
            setConfirmPromote(null)
            setMsg(`${user.name} agora é Master!`)
        } catch (err) {
            setMsg('Erro ao promover: ' + (err.response?.data?.error || err.message))
        }
    }

    const inputClass = "w-full bg-gray-800 rounded-lg px-3 py-2 mb-3 text-sm outline-none focus:ring-2 ring-indigo-500"

    return (
        <div>
            <div className="flex justify-between items-center mb-6">
                <h1 className="text-2xl font-bold">Usuários</h1>
                <button onClick={() => setShowForm(true)} className="bg-indigo-600 hover:bg-indigo-700 px-4 py-2 rounded-lg text-sm font-semibold transition">+ Novo Usuário</button>
            </div>

            {msg && <p className={`text-sm mb-4 ${msg.startsWith('Erro') ? 'text-red-400' : 'text-emerald-400'}`}>{msg}</p>}

            {showForm && (
                <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50">
                    <div className="bg-gray-900 rounded-xl p-6 w-full max-w-md border border-gray-700">
                        <h2 className="text-lg font-bold mb-4">Novo Usuário (Cliente)</h2>
                        <input className={inputClass} placeholder="Nome *" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} />
                        <input className={inputClass} placeholder="Email *" type="email" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} />
                        <input className={inputClass} placeholder="Senha *" type="password" value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} />
                        <select className={inputClass} value={form.company_id} onChange={e => setForm({ ...form, company_id: e.target.value })}>
                            <option value="">Selecione a empresa *</option>
                            {companies.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
                        </select>
                        {companies.length === 0 && <p className="text-yellow-400 text-xs mb-3">⚠️ Cadastre uma empresa primeiro!</p>}
                        <div className="flex gap-2">
                            <button onClick={handleCreate} disabled={loading || !form.company_id} className="flex-1 bg-indigo-600 hover:bg-indigo-700 disabled:opacity-50 py-2 rounded-lg text-sm font-semibold transition">{loading ? 'Criando...' : 'Criar'}</button>
                            <button onClick={() => setShowForm(false)} className="flex-1 bg-gray-700 hover:bg-gray-600 py-2 rounded-lg text-sm transition">Cancelar</button>
                        </div>
                    </div>
                </div>
            )}

            {confirmDelete && (
                <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50">
                    <div className="bg-gray-900 rounded-xl p-6 w-full max-w-sm border border-gray-700">
                        <h2 className="text-lg font-bold mb-2">Excluir Usuário</h2>
                        <p className="text-gray-400 text-sm mb-4">Tem certeza que deseja excluir <span className="text-white font-semibold">{confirmDelete.name}</span>? Esta ação não pode ser desfeita.</p>
                        <div className="flex gap-2">
                            <button onClick={() => handleDelete(confirmDelete)} className="flex-1 bg-red-600 hover:bg-red-700 py-2 rounded-lg text-sm font-semibold transition">Excluir</button>
                            <button onClick={() => setConfirmDelete(null)} className="flex-1 bg-gray-700 hover:bg-gray-600 py-2 rounded-lg text-sm transition">Cancelar</button>
                        </div>
                    </div>
                </div>
            )}

            {confirmPromote && (
                <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50">
                    <div className="bg-gray-900 rounded-xl p-6 w-full max-w-sm border border-gray-700">
                        <h2 className="text-lg font-bold mb-2">👑 Promover a Master</h2>
                        <p className="text-gray-400 text-sm mb-4">Deseja promover <span className="text-white font-semibold">{confirmPromote.name}</span> a Master? Ele terá acesso total ao sistema.</p>
                        <div className="flex gap-2">
                            <button onClick={() => handlePromote(confirmPromote)} className="flex-1 bg-indigo-600 hover:bg-indigo-700 py-2 rounded-lg text-sm font-semibold transition">👑 Promover</button>
                            <button onClick={() => setConfirmPromote(null)} className="flex-1 bg-gray-700 hover:bg-gray-600 py-2 rounded-lg text-sm transition">Cancelar</button>
                        </div>
                    </div>
                </div>
            )}

            <div className="space-y-2">
                {users.map(u => (
                    <div key={u.id} className="bg-gray-900 rounded-xl p-4 border border-gray-800 flex justify-between items-center">
                        <div>
                            <p className="font-semibold">{u.name}</p>
                            <p className="text-gray-400 text-sm">{u.email}</p>
                            {u.companies?.name && <p className="text-indigo-400 text-xs mt-1">🏢 {u.companies.name}</p>}
                        </div>
                        <div className="flex items-center gap-2">
                            <span className={`text-xs px-3 py-1 rounded-full font-semibold ${u.user_role === 'master' ? 'bg-indigo-900/50 text-indigo-300' : 'bg-gray-800 text-gray-400'}`}>
                                {u.user_role === 'master' ? '👑 Master' : '👤 Cliente'}
                            </span>
                            {u.user_role !== 'master' && (
                                <>
                                    <button onClick={() => setConfirmPromote(u)} className="text-gray-600 hover:text-indigo-400 transition text-lg" title="Promover a Master">👑</button>
                                    <button onClick={() => setConfirmDelete(u)} className="text-gray-600 hover:text-red-400 transition text-lg" title="Excluir usuário">🗑️</button>
                                </>
                            )}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}